import ScalarLoading_default from "./ScalarLoading.vue.js";
import { useLoadingState } from "./useLoadingState.js";
export { ScalarLoading_default as ScalarLoading, useLoadingState };
